module.exports = __webpack_public_path__ + "img/full0-min.d4dd82fb.png";